import { backendClient } from '../lib/api/backendClient';

export type OnboardingFlagSetting = {
  version?: number;
  seenAt?: string | null;
};

type RawSetting = { key?: unknown; value?: unknown };
type ListSettingsResponse = { settings?: RawSetting[] };

const normalizeFlagValue = (value: unknown): { version: number; seenAt: string | null } | null => {
  if (!value || typeof value !== 'object') return null;
  const obj = value as OnboardingFlagSetting;
  const version = typeof obj.version === 'number' && Number.isFinite(obj.version) ? obj.version : 1;
  const seenAt =
    typeof obj.seenAt === 'string' && obj.seenAt.trim().length > 0 ? obj.seenAt.trim() : null;
  return { version, seenAt };
};

export const onboardingSettingsService = {
  async fetchAll(): Promise<Record<string, { version: number; seenAt: string | null }>> {
    const { data } = await backendClient.get<ListSettingsResponse>('/favorites/settings');
    const rawSettings = Array.isArray(data?.settings) ? data.settings : [];
    const result: Record<string, { version: number; seenAt: string | null }> = {};

    for (const entry of rawSettings) {
      const key = typeof entry?.key === 'string' && entry.key.trim().length > 0 ? entry.key.trim() : null;
      if (!key) continue;
      const normalized = normalizeFlagValue(entry?.value);
      if (!normalized) continue;
      result[key] = normalized;
    }

    return result;
  },

  async markSeen(key: string, payload: { version?: number; seenAt: string }) {
    const version =
      typeof payload.version === 'number' && Number.isFinite(payload.version) ? payload.version : 1;
    await backendClient.put(`/favorites/settings/${key}`, { value: { version, seenAt: payload.seenAt } });
  },
};
